import React, { useEffect, useState } from 'react';
import CmsAPI from '../../../../../common/apis/CmsAPI';
import cx from 'classnames';
import { CustomButton } from '../../../../components/Button/Button';
import Icon from '../../../../components/Icon/Icon';
import styles from './ApprovalsFeedback.module.scss';
import { useTranslation } from 'react-i18next';
import ApproverInfo from '../../../../components/ApproverInfo/ApproverInfo';
import CloseButton from '../../../../components/CloseButton/CloseButton';
import { parseString } from '../../../../utils/stringHelper';
import CommentsTab from '../../../../components/CommentsTab/CommentsTab';

const commentInit = {
  authorName: '',
  content: '',
  parent: null,
  type: 2,
  username: '',
};

const commentsType = 2;

const ApprovalsFeedback = ({
  isReviewerUser,
  isMobileView,
  storyId,
  reviewer,
  title,
  isPending,
  handleClose,
  handleRemoveFromReview,
  miniSidebar,
}) => {
  const [approvalsComments, setApprovalsComments] = useState([]);
  const [isApprovalsCommentsLoading, setIsApprovalsCommentsLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [newComment, setNewComment] = useState(commentInit);

  const { t } = useTranslation();

  useEffect(() => {
    getApprovalsComments();
  }, []);

  const getApprovalsComments = async () => {
    try {
      setIsApprovalsCommentsLoading(true);
      const { result } = await CmsAPI.getComments(storyId, commentsType);
      setApprovalsComments(result || []);
    } catch (err) {
      console.log(err);
    } finally {
      setIsApprovalsCommentsLoading(false);
    }
  };

  useEffect(() => {
    if (miniSidebar) {
      handleClose();
    }
  }, [miniSidebar]);

  const removeFromReview = async () => {
    try {
      setIsLoading(true);
      await handleRemoveFromReview();
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={cx(styles.wrapper, { [styles.mobileWrapper]: isMobileView })}>
      <div className={cx(styles.approvalsHeader, { [styles.owner]: !isReviewerUser && !isMobileView })}>
        <h2>{title}</h2>
        <CloseButton onClose={handleClose} />
      </div>
      {reviewer && <ApproverInfo img={reviewer?.avatar} fullName={parseString(reviewer?.name)} />}
      <CommentsTab
        updateComments={getApprovalsComments}
        isCommentsLoading={isApprovalsCommentsLoading}
        storyId={storyId}
        comments={approvalsComments}
        commentInit={commentInit}
        newComment={newComment}
        setNewComment={setNewComment}
      />
      {isPending && (
        <div className={styles.btnWrapper}>
          <div className={styles.line} />
          <CustomButton
            variant="primary"
            label={t('general.video_action_button.remove_from_review')}
            onClick={removeFromReview}
            disabled={isLoading}
          />
        </div>
      )}
    </div>
  );
};

export default ApprovalsFeedback;
